module.exports = __webpack_public_path__ + "static/img/coins.3bbddd3d.png";